import React, { useState, useEffect } from 'react';
import { withStyles, Button,CircularProgress } from '@material-ui/core';
import { AgGrid, gridConstants as gc, filterParams, filters } from '../../../components/AgGrid';
import classnames from 'classnames';
import { ClientAccountingHistoryDetail } from '../../../components/Accounting';
import { Autocomplete } from '../../../components/Autocomplete';
import { monthsOptions, getInitialReportMonth } from '../../../helpers/constants/months';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

// SERVICES
import {
  getClientInvoicesReportHistory,
  getClientInvoiceExcel,
  getClientInvoicesHistoryPeriods,
  getClientInvoiceZipForPeriod
} from '../../../services';
import { formatNumberWithCommas } from '../../../helpers';

const styles = theme => ({});

const today = new Date();

const radios = {
  ALL: 'ALL',
  MONTHS: 'MONTHS',
};

export const ClientAccountingHistory = withStyles(styles)(props => {
  const { classes } = props;

  // const [reportMonth, setReportMonth] = useState(getInitialReportMonth);
  const [reportMonth, setReportMonth] = useState(null);
  const [selectedRadio, setSelectedRadio] = useState(radios.ALL);
  const [gridData, setGridData] = useState(null);
  const [periodOptions, setPeriodOptions] = useState(null);
  const [isGeneratingReport, setIsGeneratingReport] = useState(null);
  const columnDefs = [
    // {
    //   headerName: 'Client Excel',
    //   width: 150,
    //   filter: false,
    //   cellRenderer: (params, callerIsExport) => {
    //     if (callerIsExport || !params.data) {
    //       return;
    //     }

    //     // create the container
    //     const div = document.createElement('div');
    //     div.style = 'width: 100%; height: 100%;';

    //     const link = document.createElement('a');
    //     link.style =
    //       'width: 100%; height: 100%; display: flex; flex-driection: row; justify-content: center; align-items: center;';

    //     const linkImage = document.createElement('img');
    //     linkImage.style = 'max-width: 100%; max-height: 55%;';
    //     linkImage.src = 'assets/images/excel_icon_64x64.png';
    //     link.onclick = () => getClientInvoiceExcel(params.data);

    //     link.addEventListener('click', evt => {
    //       evt.stopPropagation();
    //     });

    //     link.appendChild(linkImage);
    //     div.appendChild(link);

    //     return div;
    //   },
    // },
    // {
    //   headerName: 'Client PDF',
    //   field: 'location',
    //   width: 150,
    //   filter: false,
    //   cellRenderer: (params, callerIsExport) => {
    //     if (callerIsExport || !params.data) {
    //       return;
    //     }

    //     const { location } = params.data;

    //     // create the container
    //     const div = document.createElement('div');
    //     div.style = 'width: 100%; height: 100%;';

    //     const link = document.createElement('a');
    //     link.style =
    //       'width: 100%; height: 100%; display: flex; flex-driection: row; justify-content: center; align-items: center;';

    //     if (location) {
    //       link.href = location;
    //     }

    //     const linkImage = document.createElement('img');
    //     linkImage.style = 'max-width: 100%; max-height: 55%;';
    //     linkImage.src = location ? 'assets/images/report_icon_25x25.png' : 'assets/images/report_unavailable_25x25.png';

    //     link.addEventListener('click', evt => {
    //       evt.stopPropagation();
    //     });

    //     link.appendChild(linkImage);
    //     div.appendChild(link);

    //     return div;
    //   },
    // },
    {
      headerName: 'Client',
      field: 'clientName',
    },
    {
      headerName: 'Invoice ID',
      field: 'invoiceId',
      cellRenderer: 'agGroupCellRenderer',
    },
    {
      headerName: 'Period',
      field: 'period',
    },
    {
      headerName: 'Invoice Total ($)',
      field: 'invoiceTotal',
      filter: filters.number,
      valueFormatter: ({ value }) => {
        return `$${formatNumberWithCommas(value, 2)}`;
      },
      // type: 'numericColumn', // right aligns the content
    },
    {
      headerName: 'Invoice Due Date',
      field: 'invoiceDueDate',
      width: gc.DATE_FIELD_WIDTH,
      cellRenderer: 'dateUTC',
      filter: filters.date,
      filterParams: filterParams.date,
      enablePivot: true,
    },
    {
      headerName: 'Invoice Date',
      field: 'invoiceDate',
      width: gc.DATE_FIELD_WIDTH,
      cellRenderer: 'dateUTC',
      filter: filters.date,
      filterParams: filterParams.date,
      enablePivot: true,
    },
    {
      headerName: 'Created By',
      field: 'createdBy',
    },
    // {
    //   headerName: 'Type',
    //   field: 'type',
    // },
  ];

  const gridOptions = {
    masterDetail: true,
    detailCellRenderer: 'ClientAccountingHistoryDetail',
    detailRowHeight: 460,
    frameworkComponents: {
      ClientAccountingHistoryDetail: params => {
        const { invoiceOrderLineTotal } = params.data;
        return <ClientAccountingHistoryDetail gridData={invoiceOrderLineTotal} />;
      },
    },
  };

  const getClientInvoicesHistoryPeriodsAsync = async () => {
    try {
      const periods = await getClientInvoicesHistoryPeriods();
      setPeriodOptions(periods);
    } catch (error) {
      console.log(error);
    }
  };

  

  const getClientInvoicesReportHistoryAsync = async period => {
    try {
      setGridData(null);
      const result = await getClientInvoicesReportHistory(period);
      setGridData(result);
    } catch (error) {
      console.log(error);
    }
  };

  const updateSelectedRadio = ({ target: { value } }) => {
    setSelectedRadio(value);
    // getClientInvoicesReportHistoryAsync(value === radios.ALL ? null : reportMonth.label);
  };
  
  const getClientInvoiceZipForPeriodAsync = async () => {
    try {
      setIsGeneratingReport(true);
      const invoicePeriod = reportMonth.label;
      await getClientInvoiceZipForPeriod({ invoicePeriod });
      
    } catch (error) {
      console.log(error);
    }
    finally{
      setIsGeneratingReport(false);
    }
  };

  useEffect(() => {
    if (selectedRadio === radios.MONTHS && !!reportMonth) {
      getClientInvoicesReportHistoryAsync(reportMonth.label);
    } else if (selectedRadio === radios.ALL) {
      getClientInvoicesReportHistoryAsync(null);
    }
  }, [reportMonth, selectedRadio]);

  useEffect(() => {
    const getInitData = () => getClientInvoicesReportHistoryAsync();

    // create a function locally so React doesn't complain
    getInitData();
    setIsGeneratingReport(false);

    // get the latest periods to fill in the options with
    getClientInvoicesHistoryPeriodsAsync();
  }, []);

  return (
    <div className={classnames('flex-1', 'col-center-center')}>
      <div className={classnames('align-stretch', 'row-start-center')} style={{ marginBottom: 15 }}>
        <FormControl component="fieldset" className={classes.formControl}>
          <RadioGroup
            row
            aria-label="selection-mode"
            name="selection-mode"
            value={selectedRadio}
            onChange={updateSelectedRadio}
          >
            <FormControlLabel
              // disabled={selectedRadio !== radios.ALL}
              value={radios.ALL}
              control={<Radio />}
              label={<div style={{ color: selectedRadio !== radios.ALL ? '#777' : 'black' }}>View all</div>}
            />
            <div style={{ width: 40 }} />
            <FormControlLabel
              // disabled={selectedRadio !== radios.MONTHS}
              value={radios.MONTHS}
              control={<Radio />}
              label={
                <div style={{ minWidth: 300 }} onClick={evt => selectedRadio === radios.MONTHS && evt.preventDefault()}>
                  <Autocomplete
                    disabled={selectedRadio !== radios.MONTHS}
                    // options={monthsOptions}
                    options={periodOptions}
                    value={reportMonth}
                    onChange={setReportMonth}
                  />
                </div>
              }
              />
        
                  <Button
                    variant="contained"
                    style={{ backgroundColor: selectedRadio !== radios.MONTHS ? '#aaa' :'var(--jmi-blue)', color: 'white', marginLeft: 10 }}
                    onClick={getClientInvoiceZipForPeriodAsync}
                    disabled={selectedRadio !== radios.MONTHS || isGeneratingReport}
                    >
                    {isGeneratingReport ? <CircularProgress size={20} style={{ color: '#aaa' }} /> : 'Export'} 
                    
                </Button>
          </RadioGroup>
                 
        </FormControl>
      </div>
      <AgGrid
        gridData={gridData}
        columnDefs={columnDefs}
        gridOptions={gridOptions}
        redirectOnClick={false}
        editOnClick={false}
      />
    </div>
  );
});
